import difference from 'lodash/difference';
import { isJiraProduct } from '@atlassian/cssxp-utils-product';
import type { State } from '../types';
import { OperationType, ProductStatus } from '../../types';
import { getLineItemsForDestinationBillingProfileChange } from '.';

/**
 * for multiple jira products from different billing profiles are forced to do account modification
 * when same family container entitlement is amended
 * here is the detailed document to explain about the bill coupled items https://hello.atlassian.net/wiki/spaces/COMITFO/pages/3269591945/Showing+bill+coupled+warning+banner
 */
export function getBillCoupledItemsForIGChange({
  products,
  invoiceGroupId,
  selectedProducts,
  cartApps,
}: {
  products: State['products'];
  invoiceGroupId?: string;
  selectedProducts: State['selectedProducts'];
  cartApps: State['linkedEntitlements'];
}): string[] {
  const selectedJiraProductEntitlementIds: string[] = [];

  const selectedProductsForBilling = Object.keys(selectedProducts);

  // getting selected jira products
  selectedProductsForBilling.forEach((id) => {
    const isNotTransfer = products?.[id].operationType !== OperationType.TRANSFER;
    const isJira = isJiraProduct(products[id].productId);
    const sourceInvoiceGroupId = products?.[id].sourceInvoiceGroupId;

    if (isJira && isNotTransfer && sourceInvoiceGroupId !== invoiceGroupId) {
      selectedJiraProductEntitlementIds.push(id);
    }
  });

  const accountModificationData = getLineItemsForDestinationBillingProfileChange({
    initialStoreProducts: products,
    invoiceGroupId,
    selectedProducts,
    cartApps,
  });
  // getting all linked selected jira products of same family container
  const coupledJiraProductEntitlementIds = accountModificationData
    ?.filter((item) => isJiraProduct(item.productId))
    ?.map((item) => item.entitlementId);

  // checking for differences of linkedJiraProducts and selectedJiraProducts
  return difference(coupledJiraProductEntitlementIds, selectedJiraProductEntitlementIds);
}
